import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import store from "./store/index";
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Amplify from "aws-amplify";
import config from "./config";

Amplify.configure({
    Auth: {
      mandatorySignIn: false,
      region: config.cognito.REGION,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
    },
    API: {
        endpoints: [
          {
            name: "contactform",
            endpoint: config.apiGateway.URL,
            region: config.apiGateway.REGION
          },
        ]
      }
    });

ReactDOM.render(
<Provider store={store}>
    <App />
</Provider>, 
document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js